import { render, staticRenderFns } from "./TRowDesktop.vue?vue&type=template&id=41f13936&scoped=true&"
import script from "./TRowDesktop.vue?vue&type=script&lang=js&"
export * from "./TRowDesktop.vue?vue&type=script&lang=js&"
import style0 from "./TRowDesktop.vue?vue&type=style&index=0&id=41f13936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f13936",
  null
  
)

export default component.exports